export interface IBnectPartner {
  projectGuid?: string;
  partnerGuid?: string;
  partnerName?: string;
  bin?: string;
  contractStart?: string;
  contractEnd?: string;
  contractSum?: number;
  rating?: number | null;
  ratingPlace?: number | null;
  inRating?: boolean;
}

export interface IExpenditure {
  guid: string;
  name: string;
}

export interface INomenclature {
  guid: string;
  name: string;
}

export interface IMeasureType {
  measureTypeId: number;
  measureTypeName: string;
}

export interface IUser {
  createTimestamp: string;
  email: string;
  firstName: string;
  firstLastName: string;
  lastName: string;
  modifyTimestamp: string;
  telephoneNumber: string;
  thumbnailPhoto: string;
  username: string;
}

export interface IPartnerCriteriaRatingUgo {
  criteriaRatingId: number;
  criteriaRatingName: string;
  value: number | null;
}

export interface IPartnerRatingUgo {
  ratingUgo: IPartnerCriteriaRatingUgo[];
  withTn?: boolean;
  userUgo?: IUser | null;
  userUgoId?: string;
  userTn?: IUser | null;
  userTnId?: string;
}

export enum ECriteriaRatingUgoType {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}
